var _title, _path;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUtah = function SvgUtah(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185.69,
    height: 235,
    viewBox: "0 0 185.69 235",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "utah")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148,229.67l47.39,6.93L199,210.21l13.48-97.27L217,70.56l-62-6.74,4.23-25.24,3.47-20.41L95.79,6.42,71.71,1.6,51.29,103.5l-10.4,57.78L34.54,191l-3.28,17.72Z",
    transform: "translate(-31.26 -1.6)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUtah, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/utah.24a1fe72.svg";
export { ForwardRef as ReactComponent };